// Genre 选项（value 为数字 ID，与后端接口对齐）
export const GENRE_OPTIONS = [
  { label: 'Pop', value: '0' },
  { label: 'Rock', value: '1' },
  { label: 'Hip Hop', value: '2' },
  { label: 'R&B', value: '3' },
  { label: 'Electronic', value: '4' },
  { label: 'Jazz', value: '5' },
  { label: 'Classical', value: '6' },
  { label: 'Country', value: '7' },
  { label: 'Reggae', value: '8' },
  { label: 'Blues', value: '9' },
  { label: 'Afrobeat', value: '10' },
  { label: 'Afro-pop', value: '11' },
  { label: 'Afro-fusion', value: '12' },
  { label: 'Gospel', value: '13' },
  { label: 'Indie', value: '14' },
  { label: 'Soul', value: '15' },
  { label: 'Funk', value: '16' },
  { label: 'Latin', value: '17' },
];

// Mood 选项（value 为数字 ID，与后端接口对齐）
export const MOOD_OPTIONS = [
  { label: 'Happy', value: '0' },
  { label: 'Sad', value: '1' },
  { label: 'Energetic', value: '2' },
  { label: 'Calm', value: '3' },
  { label: 'Romantic', value: '4' },
  { label: 'Angry', value: '5' },
  { label: 'Melancholic', value: '6' },
  { label: 'Uplifting', value: '7' },
  { label: 'Chill', value: '8' },
  { label: 'Dark', value: '9' },
  { label: 'Groovy', value: '10' },
  { label: 'Inspirational', value: '11' },
];
